<template>
    <div>
        <el-date-picker
            v-if="mode === 'edit'"
            v-bind="pickerOptions"
            v-model="tmpValue"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            type="date"
            :format="formatDate.display"
            :placeholder="placeholder"
            :clearable="clearable"
            :disabled="disabled"
            :data-bot="dataBot"
        >
        </el-date-picker>
        <p v-else>
            {{ date }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        modelValue: {
            type: [Number, String, Date],
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        canBeInThePast: {
            type: Boolean,
            required: false,
            default: true,
        },
        pastStart: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        options: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        format: {
            type: String,
            required: false,
            default: 'dmy',
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            formats: {
                dmy: {
                    display: 'DD/MM/YYYY',
                    value: 'YYYY-MM-DD HH:mm:ss',
                },
                mdy: {
                    display: 'MM/DD/YYYY',
                    value: 'YYYY-DD-MM HH:mm:ss',
                },
            },
        };
    },
    computed: {
        formatDate() {
            return this.formats[this.format];
        },
        date() {
            if (this.tmpValue) {
                return moment(this.tmpValue).format('LL');
            } else {
                return this.$l10n.__('N/C');
            }
        },
        pickerOptions() {
            if (!this.canBeInThePast) {
                const pastStart = this.pastStart;
                return {
                    ...this.options,
                    disabledDate: function (time) {
                        if (pastStart && pastStart !== '') {
                            const datePastStart = new Date(pastStart).setHours(0, 0, 0, 0);
                            return time.getTime() < datePastStart;
                        } else {
                            return time.getTime() < new Date().setHours(0, 0, 0, 0);
                        }
                    },
                };
            }
            return this.options;
        },
        tmpValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>
